import { render, staticRenderFns } from "./eventForm.vue?vue&type=template&id=63e36e49&scoped=true"
import script from "./eventForm.vue?vue&type=script&lang=js"
export * from "./eventForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e36e49",
  null
  
)

export default component.exports